import { Injectable } from '@angular/core';
import { get as _get } from 'lodash';

import { SearchResult } from '../+state/service-locator/service-locator.models';
import { Adapter } from './adapter';

@Injectable({
  providedIn: 'root'
})
export class RentalLocatorAdapter implements Adapter<SearchResult[]> {
  constructor() {}

  /**
   * Takes response from ABS Smart Locator and returns an array of SearchResult objects
   */
  adapt(items: any[]): SearchResult[] {
    const formattedResults: SearchResult[] = [];

    items.forEach(item => {
      formattedResults.push({
        id: _get(item, 'rentalLocationDetails.locationId'),
        name: _get(item, 'rentalLocationDetails.name'),
        address: {
          addressLine1: _get(item, 'rentalLocationDetails.address.addressLine1'),
          addressLine2: '',
          city: _get(item, 'rentalLocationDetails.address.city'),
          state: _get(item, 'rentalLocationDetails.address.state'),
          zipCode: _get(item, 'rentalLocationDetails.address.zip')
        },
        contactMethodDetail: {
          primaryPhoneNumber: _get(item, 'rentalLocationDetails.telephone.number'),
          fax: '',
          emailAddresses: [],
          websiteAddresses: []
        },
        aseCertified: '',
        hoursOfOperation: _get(item, 'hoursOfOperation'),
        tier: '',
        distanceInfo: {
          distance: _get(item, 'drivingDistance'),
          units: 'MILES'
        },
        coordinates: {
          latitude: _get(item, 'rentalLocationDetails.geocoordinates.latitude'),
          longitude: _get(item, 'rentalLocationDetails.geocoordinates.longitude')
        }
      });
    });
    return formattedResults;
  }
}
